import { createApp } from "vue";
import "./index.css";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import { useAuthStore } from "./store/auth";
import { useUserProfile } from "./store/userProfile";
import { createI18n } from "vue-i18n";
import EN from "./assets/translation/en.json";
import ES from "./assets/translation/es.json";
import AR from "./assets/translation/ar.json";
import CH from "./assets/translation/ch.json";
import RU from "./assets/translation/ru.json";
import FR from "./assets/translation/fr.json";
import TR from "./assets/translation/tr.json";
import { useUserPreference } from "./store/userPreferences";
import { useFontStore } from "./store/fontsStore";
import vue3GoogleLogin from "vue3-google-login";
import Vue3ColorPicker from "vue3-colorpicker";
import "vue3-colorpicker/style.css";
import { loadFont, loadGoogleFont, loadGoogleFontMethod } from "./utils/loadFont";
import { createHead } from "@vueuse/head";

const app = createApp(App);
const head = createHead();
if (import.meta.env.VITE_SENTRY_DSN) {
  try {
    import("@sentry/vue").then((Sentry) => {
      Sentry.init({
        app,
        dsn: import.meta.env.VITE_SENTRY_DSN,
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
          }),
        ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: [
          "localhost",
          /^https:\/\/yourserver\.io\/api/,
        ],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
      });
    });
  } catch (error) {}
}
loadFont(
  "Figtree",
  "https://fonts.googleapis.com/css2?family=Figtree:wght@300;400;500;700;900&display=swap",
  () => {
    console.log("Figtree font is now available for use!");
  }
);
loadGoogleFontMethod();
const pinia = createPinia();
app.use(pinia);
const authStore = useAuthStore();
authStore.fetchProductPrices();
authStore.initializeTokenFromCookies().then(() => {
  if (authStore.token) {
    const userStore = useUserProfile();
    userStore.getUserSubscription(authStore.token);
  }
});
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (requiresAuth && !authStore.token) {
    next("signing");
  } else {
    next();
  }
});
const prefStore = useUserPreference();
const i18n = createI18n({
  locale: prefStore.local,
  legacy: false,
  messages: {
    en: EN,
    es: ES,
    ar: AR,
    ch: CH,
    ru: RU,
    fr: FR,
    tr: TR,
  },
});
prefStore.loadPreferences();
app.use(i18n);
app.use(vue3GoogleLogin, {
  clientId: import.meta.env.VITE_CLOUD_GOOGLEAUTH_CLIENTID,
});
app.use(Vue3ColorPicker);
app.use(router);
app.use(head);
app.mount("#app");
